import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListFirstNameCell } from './emsp-bo-emsp-user-list-first-name.cell';
import { EmspBoEmspUserListFirstNameHeader } from './emsp-bo-emsp-user-list-first-name.header';

export const EmspBoEmspUserListFirstNameColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['firstName']
> = {
  enableSorting: true,
  header: EmspBoEmspUserListFirstNameHeader,
  cell: EmspBoEmspUserListFirstNameCell,
};
